// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"2bb0e80af6602bf4d615","691":"317331cc39d7703ca39a"}[chunkId] + ".js";
};